import capitalize from 'lodash/capitalize'
import { NONE_BUSINESS_LINE_OPTION } from 'containers/pricing/common/settings'

export const WEIGHT_DECIMAL_SCALE = 8

export const PRICE_TWO_DECIMAL_SCALE = 2

export const PRICE_FOUR_DECIMAL_SCALE = 4

export const FEE_STRUCTURE_PER_UOM = { label: 'Unit of Measure', value: 'UOM' }

const DEFAULT_UNIT_OF_MEASURE = 'TON'

export const UNIT_OF_MEASURE = {
  TON: { label: 'Ton', value: 'TON' },
  GALLON: { label: 'Gallon', value: 'GALLON' },
  ITEM: { label: 'Item', value: 'ITEM' },
  POUND: { label: 'Pound', value: 'POUND' },
  YARD: { label: 'Yard', value: 'YARD' },
}

export const UNIT_OF_MEASURE_OPTIONS = [...Object.values(UNIT_OF_MEASURE)]

export const FEE_STRUCTURE_PER_CONTAINER = { label: 'Per Container', value: 'CONTAINER' }

export const MATERIAL_FIELDS = {
  id: undefined,
  materialId: '',
  unitOfMeasure: DEFAULT_UNIT_OF_MEASURE,
  useSiteRate: false,
  useDisposalFeeRate: true,
  rate: '',
  includedTonnage: '',
  useMinimumCharge: false,
  minimumCharge: '',
  overageWeight: '',
  overageFee: '',
}

export const CONTAINER_FIELDS = {
  id: undefined,
  containerType: '',
  rate: '',
}

export const FORM_FIELDS = {
  name: '',
  description: '',
  businessLine: NONE_BUSINESS_LINE_OPTION,
  generalLedger: null,
  feeStructure: FEE_STRUCTURE_PER_UOM.value,
  materials: [{ ...MATERIAL_FIELDS }],
  containers: [{ ...CONTAINER_FIELDS }],
  deletedMaterialIds: [],
  deletedContainerIds: [],
  parentFeeId: '',
}

export const getIsPerUOM = feeStructure => feeStructure === FEE_STRUCTURE_PER_UOM.value

export const getIsPerContainer = feeStructure => feeStructure === FEE_STRUCTURE_PER_CONTAINER.value

export const getUnitOfMeasure = (feeStructure, unitOfMeasure) => {
  if (getIsPerUOM(feeStructure)) {
    return capitalize(unitOfMeasure)
  }

  if (getIsPerContainer(feeStructure)) {
    return capitalize(feeStructure)
  }

  return ''
}
